import { LegalLayout, H2 } from "./LegalLayout";
import { seller, stand } from "./legalConfig";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" testid="impressum-page">
      <H2>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</H2>
      <p>
        {seller.name}
        <br />
        Einzelunternehmer
        <br />
        {seller.street}
        <br />
        {seller.zip} {seller.city}
        <br />
        {seller.country}
      </p>

      <H2>Kontakt</H2>
      <p>
        E-Mail:{" "}
        <a href={`mailto:${seller.email}`} className="text-emerald-700 underline">
          {seller.email}
        </a>
      </p>

      <H2>Umsatzsteuer</H2>
      <p>
        Als Kleinunternehmer im Sinne des § 19 UStG wird keine Umsatzsteuer berechnet
        und entsprechend nicht ausgewiesen.
      </p>

      <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
      <p>
        {seller.name}
        <br />
        {seller.street}
        <br />
        {seller.zip} {seller.city}
      </p>

      <H2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</H2>
      <p>
        Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor
        einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <H2>Hinweis zur Art des Angebots</H2>
      <p>
        {seller.brand} stellt eine automatisierte, KI-gestützte Orientierungshilfe sowie
        eine KI-Erstbewertung von Geschäftsideen bereit. Es handelt sich{" "}
        <strong>ausdrücklich nicht</strong> um eine Rechts- oder Steuerberatung im Sinne
        des § 3 RDG bzw. § 2 StBerG und nicht um eine Tragfähigkeitsbescheinigung einer
        fachkundigen Stelle (z. B. IHK, HWK, Steuerberater) nach § 93 SGB III.
      </p>

      <p className="text-xs text-slate-400 pt-6">Stand: {stand}</p>
    </LegalLayout>
  );
}
